import {useEffect, useState} from "react";
import {
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer, RaikoCardInfoTypeOne, RaikoCardInfoTypeOneItemGenerator, RaikoCardInfoTypeOneStatusTypes,
    RaikoChipTypes,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoGridOneColumn, RaikoGridTwoColumn,
    RaikoMobileInputOutlined,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useDebounce} from "@uidotdev/usehooks";
import {GameRegistrationTypes, getGameRegistrationStatus} from "./GameRegistrationStatusType";
import {GameRegistrationService} from "../../serverService/gameService/GameRegistrationService";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {useNavigate} from "react-router-dom";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";

export default function GameRegistration({gamePeriodId, gamePeriodTitle}) {

    let page = 0;
    const size = 20;

    const [selectDisplayType, setSelectDisplayType] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [numberOfItems, setNumberOfItems] = useState(0);

    const [gameRegistrationData, setGameRegistrationData] = useState([]);

    const service = new GameRegistrationService()

    const [fullName, setFullName] = useState("");
    const _fullNameFilter = useDebounce(fullName, 500);

    const [phoneNumber, setPhoneNumber] = useState("");
    const _phoneNumberFilter = useDebounce(phoneNumber, 500);

    const [gameRegistrationStatus, setGameRegistrationStatus] = useState(GameRegistrationTypes.ALL.id);
    const _gameRegistrationStatusFilter = useDebounce(gameRegistrationStatus, 100);

    const [gameRegistrationGender, setGameRegistrationGender] = useState(GenderDetermination.ALL.id);
    const _gameRegistrationGenderFilter = useDebounce(gameRegistrationGender, 100)


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameRegistrationDataFromServer()
        }
    }, [_fullNameFilter, _phoneNumberFilter, _gameRegistrationGenderFilter, _gameRegistrationStatusFilter]);


    function gameRegistrationTablePreparation(
        id,
        number,
        fullName,
        phoneNumber,
        gender,
        city,
        culturalCenter,
        registeredAt,
        status
    ) {

        let statusChip

        if (status === GameRegistrationTypes.APPROVED.id) {
            statusChip =
                <RaikoCustomSimpleChip title={getGameRegistrationStatus(status)} type={RaikoChipTypes.success}/>
        } else if (status === GameRegistrationTypes.REJECTED.id) {
            statusChip = <RaikoCustomSimpleChip title={getGameRegistrationStatus(status)} type={RaikoChipTypes.error}/>
        } else if (status === GameRegistrationTypes.PENDING.id || status === GameRegistrationTypes.CANCELLED.id) {
            statusChip =
                <RaikoCustomSimpleChip title={getGameRegistrationStatus(status)} type={RaikoChipTypes.warning}/>
        }
        return {
            id,
            number,
            fullName,
            phoneNumber,
            gender: gender === GenderDetermination.MALE.id ? GenderDetermination.MALE.title : GenderDetermination.FEMALE.title,
            city,
            culturalCenter,
            registeredAt: convertUniversalDateToPersianDate(registeredAt),
            status: statusChip,
            statusPlace: status,
        }
    }

    function getGameRegistrationDataFromServer() {
        setTableLoading(true)
        service.getGameRegistrationList(gamePeriodId, page, size, _fullNameFilter, _phoneNumberFilter, _gameRegistrationGenderFilter, _gameRegistrationStatusFilter)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setGameRegistrationData([])
                response.data.map((item, index) => {
                    setGameRegistrationData(prevState => [
                        ...prevState,
                        gameRegistrationTablePreparation(
                            item.id,
                            (page * size) + index + 1,
                            `${item.firstName} ${item.lastName}`,
                            item.phoneNumber,
                            item.gender,
                            item.city && item.city.name ? item.city.name : "",
                            item.culturalCenter,
                            item.registeredAt,
                            item.status
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            setTableLoading(false)
        })
    }


    function handleDeleteAllFilter() {
        setPhoneNumber("")
        setGameRegistrationStatus(GameRegistrationTypes.ALL.id)
        setGameRegistrationGender(GenderDetermination.ALL.id)

    }

    const navigate = useNavigate()

    function showGameRegistrantInformation(registrantId) {

        const registrant = gameRegistrationData.find(
            (item) => item.id === Number(registrantId)
        );
        navigate(
            RouteHelper.GameRegistrantInformation.globalUrl
                .replace(":gamePeriodId", gamePeriodId)
                .replace(":registrantId", registrantId),
            {
                state: {
                    gamePeriodTitle: gamePeriodTitle,
                    gameRegistrantTitle: registrant?.fullName || ""
                },
                replace: false
            }
        );
    }

    function handleChangePage(newPage) {
        page = newPage;
        getGameRegistrationDataFromServer()
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoTableTitleContainer
                    title={"ثبت نام"}
                    amount={numberOfItems}
                    hasSelectDisplayType
                    selectDisplayType={selectDisplayType}
                    setSelectDisplayType={setSelectDisplayType}
                />
                <RaikoTableSearchContainer
                    labelText={"نام و نام خانوادگی"}
                    value={fullName}
                    setValue={setFullName}
                    hasFilter
                    handleDeleteAllFilters={handleDeleteAllFilter}
                    filterStatus={
                        phoneNumber.length > 0 ||
                        gameRegistrationStatus.length > 0 &&
                        GameRegistrationTypes.ALL.id !== gameRegistrationStatus ||
                        gameRegistrationGender.length > 0 &&
                        GenderDetermination.ALL.id !== gameRegistrationGender
                    }
                >
                    <RaikoGridOneColumn>
                        <RaikoMobileInputOutlined
                            labelText={"شماره همراه"}
                            value={phoneNumber}
                            setValue={setPhoneNumber}/>
                        <RaikoCustomSelect
                            labelText={"جنسیت"}
                            value={gameRegistrationGender}
                            setValue={setGameRegistrationGender}
                            items={[
                                raikoCustomSelectItemGenerator(GenderDetermination.ALL.id, GenderDetermination.ALL.title),
                                raikoCustomSelectItemGenerator(GenderDetermination.MALE.id, GenderDetermination.MALE.title),
                                raikoCustomSelectItemGenerator(GenderDetermination.FEMALE.id, GenderDetermination.FEMALE.title),
                            ]}
                        />
                        <RaikoCustomSelect
                            labelText={"وضعیت"}
                            value={gameRegistrationStatus}
                            setValue={setGameRegistrationStatus}
                            items={[
                                raikoCustomSelectItemGenerator(GameRegistrationTypes.ALL.id, GameRegistrationTypes.ALL.title),
                                raikoCustomSelectItemGenerator(GameRegistrationTypes.APPROVED.id, GameRegistrationTypes.APPROVED.title),
                                raikoCustomSelectItemGenerator(GameRegistrationTypes.PENDING.id, GameRegistrationTypes.PENDING.title),
                                raikoCustomSelectItemGenerator(GameRegistrationTypes.REJECTED.id, GameRegistrationTypes.REJECTED.title),
                                raikoCustomSelectItemGenerator(GameRegistrationTypes.CANCELLED.id, GameRegistrationTypes.CANCELLED.title),
                            ]}

                        />
                    </RaikoGridOneColumn>
                </RaikoTableSearchContainer>

                <RaikoCustomTable
                    header={gameRegistrationListHeader}
                    data={gameRegistrationData}
                    isLoading={tableLoading}
                    pageCount={pageCount}
                    selectDisplayType={selectDisplayType}
                    handlePaginationChange={handleChangePage}
                    rowClicked={showGameRegistrantInformation}
                >
                    <RaikoGridTwoColumn className={css`padding: 3px`}>
                        {
                            gameRegistrationData.map((item, index) => {
                                return <RaikoCardInfoTypeOne
                                    key={index}
                                    title={item.fullName}
                                    titleLabel={item.phoneNumber}
                                    status
                                    statusType={
                                        item.statusPlace === GameRegistrationTypes.PENDING.id || item.statusPlace ===
                                        GameRegistrationTypes.CANCELLED.id ? RaikoCardInfoTypeOneStatusTypes.WARNING :
                                            item.statusPlace === GameRegistrationTypes.REJECTED.id ? RaikoCardInfoTypeOneStatusTypes.ERROR :
                                                RaikoCardInfoTypeOneStatusTypes.SUCCESS
                                    }
                                    statusText={
                                        item.statusPlace === GameRegistrationTypes.APPROVED.id ? GameRegistrationTypes.APPROVED.title :
                                            item.statusPlace === GameRegistrationTypes.REJECTED.id ? GameRegistrationTypes.REJECTED.title :
                                                item.statusPlace === GameRegistrationTypes.PENDING.id ? GameRegistrationTypes.PENDING.title :
                                                    GameRegistrationTypes.CANCELLED.title
                                    }
                                    items={[
                                        RaikoCardInfoTypeOneItemGenerator("جنسیت", item.gender),
                                        RaikoCardInfoTypeOneItemGenerator("شهر", item.city),
                                        RaikoCardInfoTypeOneItemGenerator("فرهنگسرا", item.culturalCenter),
                                        RaikoCardInfoTypeOneItemGenerator("تاریخ ثبت نام", item.registeredAt),
                                    ]}
                                    onClick={()=>{
                                        showGameRegistrantInformation(item.id)
                                    }}
                                />
                            })
                        }
                    </RaikoGridTwoColumn>

                </RaikoCustomTable>
            </RaikoGridOneColumn>

        </RaikoBaseCardContainer>
    )
}
const gameRegistrationListHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "fullName",
        label: "نام و نام خانوادگی"
    },
    {
        id: "phoneNumber",
        label: "شماره همراه"
    },
    {
        id: "gender",
        label: "جنسیت"
    },
    {
        id: "city",
        label: "شهر"
    },
    {
        id: "culturalCenter",
        label: "فرهنگسرا"
    },
    {
        id: "registeredAt",
        label: "تاریخ ثبت نام"
    },
    {
        id: "status",
        label: "وضعیت"
    },
]
export const GenderDetermination = {
    ALL: {
        id: "ALL",
        title: "همه"
    },
    MALE: {
        id: "MALE",
        title: "مرد"
    },
    FEMALE: {
        id: "FEMALE",
        title: "زن"
    },
}